import React from 'react'
import { Link } from 'react-router-dom'
import axios from 'axios'
import Constant from '../../Constant'
import CheckPermission from '../Permissions/CheckPermission'
class SideNavBar extends React.Component {
  state = {
    categoryList: [],
  }

  componentDidMount() {
    this.dashbord()
  }

  dashbord = async () => {
    var that = this

    await axios
      .get(Constant.getAPI() + '/cruise/list-cruise-masters', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          that.setState({
            categoryList: res.data.data,
          })
        }
      })
  }

  render() {
    return (
      <nav
        className="pcoded-navbar noprint"
        id="admin_menu"
      >
        <div className="pcoded-inner-navbar main-menu">
          <ul className="pcoded-item pcoded-left-item">
            <li className="">
              <Link to="/">
                <span className="pcoded-micon">
                  <i className="feather icon-home"></i>
                </span>
                <span className="pcoded-mtext">Dashboard</span>
              </Link>
            </li>
            <li className="">
              <Link to="/all-users">
                <span className="pcoded-micon">
                  <i className="icofont icofont-users-alt-3"></i>
                </span>
                <span className="pcoded-mtext">Users Master</span>
              </Link>
            </li>
            <li className="pcoded-hasmenu">
              <a
                href="#"
                onClick={(e) => e.preventDefault()}
              >
                <span className="pcoded-micon">
                  <i className="icofont icofont-folder"></i>
                </span>
                <span className="pcoded-mtext">Concierge</span>
              </a>
              <ul className="pcoded-submenu">
                <li className="">
                  <Link to="/concierge-cruise">
                    <span className="pcoded-micon">
                      <i className="icofont icofont-life-buoy"></i>
                    </span>
                    <span className="pcoded-mtext">Cruise Booking</span>
                  </Link>
                </li>
                <li className="">
                  <Link to="/concierge-event">
                    <span className="pcoded-micon">
                      <i className="icofont icofont-life-buoy"></i>
                    </span>
                    <span className="pcoded-mtext">Event Booking</span>
                  </Link>
                </li>
                <li className="">
                  <Link to="/concierge-kashta-book">
                    <span className="pcoded-micon">
                      <i className="icofont icofont-life-buoy"></i>
                    </span>
                    <span className="pcoded-mtext">Kashta Booking</span>
                  </Link>
                </li>
                <li className="">
                  <Link to="/concierge-chalet">
                    <span className="pcoded-micon">
                      <i className="icofont icofont-life-buoy"></i>
                    </span>
                    <span className="pcoded-mtext">Chalet Booking</span>
                  </Link>
                </li>
              </ul>
            </li>
          </ul>
          <div className="pcoded-navigatio-lavel">Master</div>
          <ul className="pcoded-item pcoded-left-item">
            <li className="pcoded-hasmenu">
              <a
                href="#"
                onClick={(e) => e.preventDefault()}
              >
                <span className="pcoded-micon">
                  <i className="icofont icofont-cart"></i>
                </span>
                <span className="pcoded-mtext">Booking Master</span>
              </a>
              <ul className="pcoded-submenu">
                <li className=" ">
                  <Link to="/all-bookings/CRUISE">
                    <span className="pcoded-mtext">Bookings</span>
                  </Link>
                </li>
                <li className=" ">
                  <Link to="/booking-payments">
                    <span className="pcoded-mtext">Payments</span>
                  </Link>
                </li>
              </ul>
            </li>
            <li className="">
              <Link to="/cruise-complaint">
                <span className="pcoded-micon">
                  <i className="icofont icofont-contacts"></i>
                </span>
                <span className="pcoded-mtext">Complaint Master</span>
              </Link>
            </li>
            <li className="pcoded-hasmenu">
              <a
                href="#"
                onClick={(e) => e.preventDefault()}
              >
                <span className="pcoded-micon">
                  <i className="icofont icofont-sail-boat-alt-1"></i>
                </span>
                <span className="pcoded-mtext">Boat Master</span>
              </a>
              <ul className="pcoded-submenu">
                {this.state.categoryList?.map(
                  (itm) =>
                    itm.is_active &&
                    itm.category_type == 'CRUISE' && (
                      <li
                        className=" "
                        key={itm.id}
                      >
                        <Link to={`/boatsmaster/${itm.cruise_cat_en}/${itm.id}`}>
                          <span className="pcoded-mtext">{itm.cruise_cat_en} List</span>
                        </Link>
                      </li>
                    )
                )}
              </ul>
            </li>
            <li className="pcoded-hasmenu">
              <a
                href="#"
                onClick={(e) => e.preventDefault()}
              >
                <span className="pcoded-micon">
                  <i className="icofont icofont-users-alt-3"></i>
                </span>
                <span className="pcoded-mtext">Event Master</span>
              </a>
              <ul className="pcoded-submenu">
                <li className="">
                  <Link to="/event-companies">
                    <span className="pcoded-micon">
                      <i className="icofont icofont-life-buoy"></i>
                    </span>
                    <span className="pcoded-mtext">Event Company </span>
                  </Link>
                </li>
                <li className="">
                  <Link to="/event-category">
                    <span className="pcoded-micon">
                      <i className="icofont icofont-life-buoy"></i>
                    </span>
                    <span className="pcoded-mtext">Event Category </span>
                  </Link>
                </li>
                <li className="">
                  <Link to="/top-event-category">
                    <span className="pcoded-micon">
                      <i className="icofont icofont-life-buoy"></i>
                    </span>
                    <span className="pcoded-mtext">Top Event Category </span>
                  </Link>
                </li>
              </ul>
            </li>
            <li className="pcoded-hasmenu">
              <a
                href="#"
                onClick={(e) => e.preventDefault()}
              >
                <span className="pcoded-micon">
                  <i className="icofont icofont-cart-alt"></i>
                </span>
                <span className="pcoded-mtext">Store Master</span>
              </a>
              <ul className="pcoded-submenu">
                <li className="">
                  <Link to="/store-details">
                    <span className="pcoded-micon">
                      <i className="icofont icofont-brand-appstore"></i>
                    </span>
                    <span className="pcoded-mtext">Stores</span>
                  </Link>
                </li>
                <li className=" ">
                  <Link to="/item-categories">
                    <span className="pcoded-micon">
                      <i className="icofont icofont-library"></i>
                    </span>
                    <span className="pcoded-mtext">Item Categories</span>
                  </Link>
                </li>
                <li className="">
                  <Link to="/store-map-view">
                    <span className="pcoded-micon">
                      <i className="icofont icofont-opposite"></i>
                    </span>
                    <span className="pcoded-mtext">Store Map</span>
                  </Link>
                </li>
              </ul>
            </li>
            <li className="pcoded-hasmenu">
              <a
                href="#"
                onClick={(e) => e.preventDefault()}
              >
                <span className="pcoded-micon">
                  <i className="icofont icofont-home"></i>
                </span>
                <span className="pcoded-mtext">Chalet Master</span>
              </a>
              <ul className="pcoded-submenu">
                <li className="">
                  <Link to="/chalet-master">
                    <span className="pcoded-mtext">Chalet List</span>
                  </Link>
                </li>
                <li className="">
                  <Link to="/chalet-category">
                    <span className="pcoded-mtext">Chalet Category</span>
                  </Link>
                </li>
                <li className="">
                  <Link to="/chalet-global-packages">
                    <span className="pcoded-mtext">Chalet Packages</span>
                  </Link>
                </li>
              </ul>
            </li>
            <li className="pcoded-hasmenu">
              <a
                href="#"
                onClick={(e) => e.preventDefault()}
              >
                <span className="pcoded-micon">
                  <i className="icofont icofont-car"></i>
                </span>
                <span className="pcoded-mtext">Car Master</span>
              </a>
              <ul className="pcoded-submenu">
                <li className="">
                  <Link to="/car-company">
                    <span className="pcoded-mtext">Car Company</span>
                  </Link>
                </li>
                <li className="">
                  <Link to="/car-category">
                    <span className="pcoded-mtext">Car Category</span>
                  </Link>
                </li>
                <li className="">
                  <Link to="/car-pickup">
                    <span className="pcoded-mtext">Car Pickups</span>
                  </Link>
                </li>
              </ul>
            </li>
            {localStorage.getItem('user_role') !== 'ops-coord' && (
              <li className="pcoded-hasmenu">
                <a
                  href="#"
                  onClick={(e) => e.preventDefault()}
                >
                  <span className="pcoded-micon">
                    <i className="icofont icofont-airplane"></i>
                  </span>
                  <span className="pcoded-mtext">Airport Master</span>
                </a>
                <ul className="pcoded-submenu">
                  <li className="">
                    <Link to="/airport-list">
                      <span className="pcoded-micon">
                        <i className="icofont icofont-airplane"></i>
                      </span>
                      <span className="pcoded-mtext">Airport List</span>
                    </Link>
                  </li>
                  {['super-admin', 'owners', 'mkt-mgr', 'mkt-coord'].includes(localStorage.getItem('user_role')) && (
                    <li className="">
                      <Link to="/flight-redirect-list">
                        <span className="pcoded-micon">
                          <i className="icofont icofont-airplane"></i>
                        </span>
                        <span className="pcoded-mtext">Flight Redirect List</span>
                      </Link>
                    </li>
                  )}
                </ul>
              </li>
            )}
            <li className="pcoded-hasmenu">
              <a
                href="#"
                onClick={(e) => e.preventDefault()}
              >
                <span className="pcoded-micon">
                  <i className="icofont icofont-sail-boat-alt-1"></i>
                </span>
                <span className="pcoded-mtext">Cruise Trip Master</span>
              </a>
              <ul className="pcoded-submenu">
                <li className="">
                  <Link to="/cruise-trip-destination">
                    <span className="pcoded-micon">
                      <i className="icofont icofont-sail-boat-alt-1"></i>
                    </span>
                    <span className="pcoded-mtext">Trip Destinations</span>
                  </Link>
                </li>
                <li className="">
                  <Link to="/trip-cruise">
                    <span className="pcoded-micon">
                      <i className="icofont icofont-sail-boat-alt-1"></i>
                    </span>
                    <span className="pcoded-mtext">Trip Cruises</span>
                  </Link>
                </li>
                <li className="">
                  <Link to="/cruise-trip">
                    <span className="pcoded-micon">
                      <i className="icofont icofont-sail-boat-alt-1"></i>
                    </span>
                    <span className="pcoded-mtext">Trips</span>
                  </Link>
                </li>
              </ul>
            </li>
            <CheckPermission permission={'view-admin-review'}>
              <li className=" ">
                <Link to="/admin-review">
                  <span className="pcoded-micon">
                    <i className="icofont icofont-star"></i>
                  </span>
                  <span className="pcoded-mtext">Review Master</span>
                </Link>
              </li>
            </CheckPermission>
            <li className="">
              <Link to="/offers">
                <span className="pcoded-micon">
                  <i className="icofont icofont-sale-discount"></i>
                </span>
                <span className="pcoded-mtext">Offer Master</span>
              </Link>
            </li>
            <li className="pcoded-hasmenu">
              <a
                href="#"
                onClick={(e) => e.preventDefault()}
              >
                <span className="pcoded-micon">
                  <i className="icofont icofont-users-alt-3"></i>
                </span>
                <span className="pcoded-mtext">Address Master</span>
              </a>
              <ul className="pcoded-submenu">
                <li className="">
                  <Link to="/des-tination-list">
                    <span className="pcoded-micon">
                      <i className="icofont icofont-opposite"></i>
                    </span>
                    <span className="pcoded-mtext">Destination Point List</span>
                  </Link>
                </li>
                <li className="">
                  <Link to="/pick-up-list">
                    <span className="pcoded-micon">
                      <i className="icofont icofont-speed-boat"></i>
                    </span>
                    <span className="pcoded-mtext">Pick Up Point List</span>
                  </Link>
                </li>
                <li className="">
                  <Link to="/governorate">
                    <span className="pcoded-micon">
                      <i className="icofont icofont-brand-appstore"></i>
                    </span>
                    <span className="pcoded-mtext">Governorate</span>
                  </Link>
                </li>
                <li className="">
                  <Link to="/city">
                    <span className="pcoded-micon">
                      <i className="icofont icofont-opposite"></i>
                    </span>
                    <span className="pcoded-mtext">Area</span>
                  </Link>
                </li>
              </ul>
            </li>
            <li>
              <Link to="/trips">
                <span className="pcoded-micon">
                  <i className="icofont icofont-sail-boat-alt-1"></i>
                </span>
                <span className="pcoded-mtext">Trips Master</span>
              </Link>
            </li>
            <li className="pcoded-hasmenu">
              <a
                href="#"
                onClick={(e) => e.preventDefault()}
              >
                <span className="pcoded-micon">
                  <i className="icofont icofont-library"></i>
                </span>
                <span className="pcoded-mtext">Addons Master</span>
              </a>
              <ul className="pcoded-submenu">
                <li className="">
                  <Link to="/diwaniya-categories">
                    <span className="pcoded-micon">
                      <i className="icofont icofont-opposite"></i>
                    </span>
                    <span className="pcoded-mtext">Addons Categories</span>
                  </Link>
                </li>
                <li className="">
                  <Link to="/diwaniya">
                    <span className="pcoded-micon">
                      <i className="icofont icofont-opposite"></i>
                    </span>
                    <span className="pcoded-mtext">Addons</span>
                  </Link>
                </li>
              </ul>
            </li>
            {['super-admin', 'owners', 'ops-sup'].includes(localStorage.getItem('user_role')) && (
              <>
                <li className=" ">
                  <Link to="/bannerModule-lists">
                    <span className="pcoded-micon">
                      <i className="icofont icofont-image"></i>
                    </span>
                    <span className="pcoded-mtext">Banner Master </span>
                  </Link>
                </li>
                <li className="">
                  <Link to="/timeslot">
                    <span className="pcoded-micon">
                      <i className="icofont icofont-calendar"></i>
                    </span>
                    <span className="pcoded-mtext">Time Slot Master</span>
                  </Link>
                </li>
              </>
            )}
            <li className=" ">
              <Link to="/coupon-controller">
                <span className="pcoded-micon">
                  <i className="icofont icofont-sale-discount"></i>
                </span>
                <span className="pcoded-mtext">Coupons Master</span>
              </Link>
            </li>
            {localStorage.getItem('user_role') !== 'ops-coord' && (
              <>
                <li className="">
                  <Link to="/vendor">
                    <span className="pcoded-micon">
                      <i className="icofont icofont-infinite"></i>
                    </span>
                    <span className="pcoded-mtext">Vendors</span>
                  </Link>
                </li>
                <li className=" ">
                  <Link to="/ads">
                    <span className="pcoded-micon">
                      <i className="icofont icofont-image"></i>
                    </span>
                    <span className="pcoded-mtext">Ads Master</span>
                  </Link>
                </li>
                <li className=" ">
                  <Link to="/notification-v2">
                    <span className="pcoded-micon">
                      <i className="icofont icofont-notification"></i>
                    </span>
                    <span className="pcoded-mtext">Notification</span>
                  </Link>
                </li>
              </>
            )}
            <CheckPermission permission={'manage-voucher'}>
              <li className="">
                <Link to="/voucher">
                  <span className="pcoded-micon">
                    <i className="icofont icofont-wallet"></i>
                  </span>
                  <span className="pcoded-mtext">Voucher</span>
                </Link>
              </li>
            </CheckPermission>

            <li className="pcoded-hasmenu">
              <a
                href="#"
                onClick={(e) => e.preventDefault()}
              >
                <span className="pcoded-micon">
                  <i className="feather icon-map-pin"></i>
                </span>
                <span className="pcoded-mtext">Reports</span>
              </a>
              <ul className="pcoded-submenu">
                <CheckPermission permission={'annual-report'}>
                  <li className="">
                    <Link to="/annual-report">
                      <span className="pcoded-mtext">Annual Report</span>
                    </Link>
                  </li>
                </CheckPermission>
                <li className="">
                  <Link to="/basic-report-cruise/basic-report">
                    <span className="pcoded-mtext">Basic Report (Cruise)</span>
                  </Link>
                </li>
                <li className="">
                  <Link to="/basic-report-chalet">
                    <span className="pcoded-mtext">Basic Report (Chalet)</span>
                  </Link>
                </li>
                <li className="">
                  <Link to="/event-reports">
                    <span className="pcoded-mtext">Basic Report (Event)</span>
                  </Link>
                </li>
                <li className="">
                  <Link to="/trip-reports">
                    <span className="pcoded-mtext">Basic Report (Trip)</span>
                  </Link>
                </li>
                <li className="">
                  <Link to="/store-report">
                    <span className="pcoded-mtext">Store Report</span>
                  </Link>
                </li>
                {localStorage.getItem('user_role') !== 'ops-coord' && (
                  <>
                    <li className="">
                      <Link to="/complaint-report">
                        <span className="pcoded-mtext">Complaint Report</span>
                      </Link>
                    </li>
                    <li className="">
                      <Link to="/financial-report">
                        <span className="pcoded-mtext">Financial Report (Cruise)</span>
                      </Link>
                    </li>
                    <li className="">
                      <Link to="/wallet-reports">
                        <span className="pcoded-mtext">Wallet Reports</span>
                      </Link>
                    </li>
                    <li className="">
                      <Link to="/cruise-id-report">
                        <span className="pcoded-mtext">Cruise List Report</span>
                      </Link>
                    </li>
                    <li className="">
                      <Link to="/basic-report-cruise/customer-booking-report">
                        <span className="pcoded-mtext">Customer Bookings Report</span>
                      </Link>
                    </li>
                    <li className=" ">
                      <Link to="/fandb-sales-summary-report">
                        <span className="pcoded-mtext">F&B Sales Summary Report</span>
                      </Link>
                    </li>
                    <li className=" ">
                      <Link to="/new-user-report">
                        <span className="pcoded-mtext">User Report</span>
                      </Link>
                    </li>
                    <li className=" ">
                      <Link to="/coupon-report">
                        <span className="pcoded-mtext">Coupon Status Report</span>
                      </Link>
                    </li>
                    <li className=" ">
                      <Link to="/mina-report">
                        <span className="pcoded-mtext">Mina Report</span>
                      </Link>
                    </li>
                  </>
                )}
                <CheckPermission permission={'manage-voucher'}>
                  <li className="">
                    <Link to="/voucher-reports">
                      <span className="pcoded-mtext">Voucher Reports</span>
                    </Link>
                  </li>
                </CheckPermission>
              </ul>
            </li>
            {/* <li className=" pcoded-hasmenu">
							<a href="#" onClick={(e) => e.preventDefault()}>
								<span className="pcoded-micon">
									<i className="icofont icofont-cart-alt"></i>
								</span>
								<span className="pcoded-mtext">Shop</span>
							</a>
							<ul className="pcoded-submenu">
								<li className="">
									<Link to="/shop-categories">
										<span className="pcoded-micon">
											<i className="icofont icofont-opposite"></i>
										</span>
										<span className="pcoded-mtext">Shop categories </span>
									</Link>
								</li>
							</ul>
						</li> */}
            {/* <li>
							<Link to="/activities-master">
								<span className="pcoded-micon">
									<i className="icofont icofont-sail-boat-alt-1"></i>
								</span>
								<span className="pcoded-mtext">Activities Master</span>
							</Link>
						</li>
						<li>
							<Link to="/offers-master">
								<span className="pcoded-micon">
									<i className="icofont icofont-sail-boat-alt-1"></i>
								</span>
								<span className="pcoded-mtext">Offers Master</span>
							</Link>
						</li> */}
          </ul>
          <div className="pcoded-navigatio-lavel">Settings</div>
          <ul className="pcoded-item pcoded-left-item">
            <CheckPermission permission={'service-categories'}>
              <li className="">
                <Link to="/category">
                  <span className="pcoded-micon">
                    <i className="icofont icofont-sail-boat-alt-2"></i>
                  </span>
                  <span className="pcoded-mtext">Service Categories</span>
                </Link>
              </li>
            </CheckPermission>
            <CheckPermission permission={'manage-journeys'}>
              <li className=" ">
                <Link to="/journey-list">
                  <span className="pcoded-micon">
                    <i className="icofont icofont-settings"></i>
                  </span>
                  <span className="pcoded-mtext">Manage Journeys</span>
                </Link>
              </li>
            </CheckPermission>
            <CheckPermission permission={'manage-payment-settings'}>
              <li className=" ">
                <Link to="/payment-type">
                  <span className="pcoded-micon">
                    <i className="icofont icofont-money"></i>
                  </span>
                  <span className="pcoded-mtext">Payment Settings</span>
                </Link>
              </li>
            </CheckPermission>
            {localStorage.getItem('user_role') !== 'ops-coord' && (
              <>
                <li className=" ">
                  <Link to="/version-history">
                    <span className="pcoded-micon">
                      <i className="icofont icofont-image"></i>
                    </span>
                    <span className="pcoded-mtext">Version History Settings</span>
                  </Link>
                </li>
                <li className="">
                  <Link to="/home-messages">
                    <span className="pcoded-micon">
                      <i className="icofont icofont-image"></i>
                    </span>
                    <span className="pcoded-mtext">Home Screen Msg</span>
                  </Link>
                </li>
                <li className="">
                  <Link to="/onboard-setting">
                    <span className="pcoded-micon">
                      <i className="icofont icofont-image"></i>
                    </span>
                    <span className="pcoded-mtext">Onboarding Data Setting</span>
                  </Link>
                </li>
                <li className="">
                  <Link to="/cruise-facilities">
                    <span className="pcoded-micon">
                      <i className="icofont icofont-image"></i>
                    </span>
                    <span className="pcoded-mtext">Facilities</span>
                  </Link>
                </li>
              </>
            )}
            <li className="pcoded-hasmenu">
              <a
                href="#"
                onClick={(e) => e.preventDefault()}
              >
                <span className="pcoded-micon">
                  <i className="feather icon-map-pin"></i>
                </span>
                <span className="pcoded-mtext">Policies</span>
              </a>
              <ul className="pcoded-submenu">
                <li className="">
                  <Link to="/terms-conditions-user">
                    <span className="pcoded-micon">
                      <i className="icofont icofont-law-document"></i>
                    </span>
                    <span className="pcoded-mtext">Terms & conditions (User)</span>
                  </Link>
                </li>
                <li className="">
                  <Link to="/terms-conditions-owner">
                    <span className="pcoded-micon">
                      <i className="icofont icofont-law-document"></i>
                    </span>
                    <span className="pcoded-mtext">Terms & conditions (Owner)</span>
                  </Link>
                </li>
                <li className="">
                  <Link to="/privacy-policy-user">
                    <span className="pcoded-micon">
                      <i className="feather icon-refresh-ccw"></i>
                    </span>
                    <span className="pcoded-mtext">Privacy Policy (User)</span>
                  </Link>
                </li>
                <li className="">
                  <Link to="/privacy-policy-owner">
                    <span className="pcoded-micon">
                      <i className="feather icon-refresh-ccw"></i>
                    </span>
                    <span className="pcoded-mtext">Privacy Policy (Owner)</span>
                  </Link>
                </li>
                <li className="">
                  <Link to="/refund-policy">
                    <span className="pcoded-micon">
                      <i className="feather icon-refresh-ccw"></i>
                    </span>
                    <span className="pcoded-mtext">Refund Policy</span>
                  </Link>
                </li>
                <li className="">
                  <Link to="/yacht-policy">
                    <span className="pcoded-micon">
                      <i className="feather icon-refresh-ccw"></i>
                    </span>
                    <span className="pcoded-mtext">Yacht Policy</span>
                  </Link>
                </li>
                <li className="">
                  <Link to="/seller-policy">
                    <span className="pcoded-micon">
                      <i className="feather icon-refresh-ccw"></i>
                    </span>
                    <span className="pcoded-mtext">Captain Policy</span>
                  </Link>
                </li>
                <li className="">
                  <Link to="/buyer-policy">
                    <span className="pcoded-micon">
                      <i className="feather icon-refresh-ccw"></i>
                    </span>
                    <span className="pcoded-mtext">Buyer Policy</span>
                  </Link>
                </li>
                <li className="">
                  <Link to="/chalet-policy">
                    <span className="pcoded-mtext">Chalet Policy</span>
                  </Link>
                </li>
                <li className="">
                  <Link to="/chalet-refund-policy">
                    <span className="pcoded-mtext">Chalet Refund Policy</span>
                  </Link>
                </li>
                <li className="">
                  <Link to="/data-deletion-policy">
                    <span className="pcoded-mtext">Data Deletion Policy</span>
                  </Link>
                </li>
                <li className="">
                  <Link to="/about">
                    <span className="pcoded-micon">
                      <i className="icofont icofont-law-document"></i>
                    </span>
                    <span className="pcoded-mtext">About Us</span>
                  </Link>
                </li>
              </ul>
            </li>
            <CheckPermission permission={'manage-countries'}>
              <li className="">
                <Link to="/country-admin">
                  <span className="pcoded-micon">
                    <i className="icofont icofont-police"></i>
                  </span>
                  <span className="pcoded-mtext">Country Admins</span>
                </Link>
              </li>
            </CheckPermission>
            <li className="">
              <Link to="/contact-us">
                <span className="pcoded-micon">
                  <i className="feather icon-phone"></i>
                </span>
                <span className="pcoded-mtext">Contact Us</span>
              </Link>
            </li>
            {localStorage.getItem('user_role') !== 'ops-coord' && (
              <>
                <li className="">
                  <Link to="/faq-list">
                    <span className="pcoded-micon">
                      <i className="icofont icofont-contacts"></i>
                    </span>
                    <span className="pcoded-mtext">FAQ</span>
                  </Link>
                </li>
                <CheckPermission permission={'client-setting'}>
                  <li className="">
                    <Link to="/client-setting">
                      <span className="pcoded-micon">
                        <i className="feather icon-refresh-ccw"></i>
                      </span>
                      <span className="pcoded-mtext">Settings</span>
                    </Link>
                  </li>
                </CheckPermission>
                <li className="">
                  <Link to="/uploads">
                    <span className="pcoded-micon">
                      <i className="icofont icofont-upload-alt"></i>
                    </span>
                    <span className="pcoded-mtext">Uploads(Temp Images)</span>
                  </Link>
                </li>
              </>
            )}
          </ul>
        </div>
      </nav>
    )
  }
}

export default SideNavBar
